import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import {dateToString, type} from './../../util/core'

export const GeneralVehicleInfoGrid = function({shareVehicleDetails}) {
    const wheels = Object.keys(shareVehicleDetails.wheelDto).map(x => shareVehicleDetails.wheelDto[x]);
    return (
        <Grid>
            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m:0.4 },
                }}
                noValidate
                autoComplete="off">
                    <TextField
                        label="Erstzulassung"
                        size="small"
                        value={dateToString(new Date(shareVehicleDetails.firstRegistration), 'MM.yyyy')}
                        variant='outlined'
                        color="grey"
                        focused
                        inputProps={
                            { readOnly: true, style: {fontSize: 12}}
                        }
                        InputLabelProps={{style: {fontSize: 14}}}
                    />
                    <TextField
                        label="KM-Laufleistung"
                        size="small"
                        value={shareVehicleDetails.milage+" km"}
                        variant='outlined'
                        color="grey"
                        focused
                        inputProps={
                            { readOnly: true, style: {fontSize: 12}}
                        }
                        InputLabelProps={{style: {fontSize: 14}}}
                    />
                    <TextField
                        label="Kraftstoffart"
                        size="small"
                        value={shareVehicleDetails.fuelType}
                        variant='outlined'
                        color="grey"
                        focused
                        inputProps={
                            { readOnly: true, style: {fontSize: 12}}
                        }
                        InputLabelProps={{style: {fontSize: 14}}}
                    />
                    <TextField
                        label="Hubraum"
                        size="small"
                        value={shareVehicleDetails.cubicCapacity}
                        focused
                        color="grey"
                        variant='outlined'
                        inputProps={
                            { readOnly: true, style: {fontSize: 12}}
                        }
                        InputLabelProps={{style: {fontSize: 14}}}
                    />
                    <TextField
                        label="Leistung"
                        size="small"
                        value={shareVehicleDetails.powerKw + " kW / " + shareVehicleDetails.powerPS + " PS"}
                        variant='outlined'
                        color="grey"
                        focused
                        inputProps={
                            { readOnly: true, style: {fontSize: 12}}
                        }
                        InputLabelProps={{style: {fontSize: 14}}}
                    />
                    <TextField
                        label="Antriebsart"
                        size="small"
                        value={shareVehicleDetails.wheelFormula}
                        variant='outlined'
                        color="grey"
                        focused
                        inputProps={
                            { readOnly: true, style: {fontSize: 12}}
                        }
                        InputLabelProps={{style: {fontSize: 14}}}
                    />
            </Box>

            <Box
                component="form"
                sx={{
                    '& .MuiTextField-root': { m:0.4 },
                    mt: 2,
                }}
                noValidate
                autoComplete="off">
                {
                    wheels.some(x => !type.isStringNullOrEmpty(x.description)) ? <p style={{fontSize:'14px'}}>Profiltiefen</p> : ''
                }
                {
                    wheels
                        .sort((e1, e2) => e1.order > e2.order)
                        .map(wheelInfo => {
                        const isDescriptionNull = type.isStringNullOrEmpty(wheelInfo.description);
                        if(isDescriptionNull) return;
                        return(<TextField
                            label={wheelInfo.title}
                            size="small"
                            key={`item-${wheelInfo.order}`}
                            variant='outlined'
                            value={wheelInfo.description}
                            color="grey"
                            focused
                            inputProps={
                                { readOnly: true, style: {fontSize: 12}}
                            }
                            InputLabelProps={{style: {fontSize: 14}}}
                        />);
                    })
                }
            </Box>
        </Grid>
    );
}